/*
 * PF OS — Bevakningar (mig 394).
 *
 * Hjärtat sparar ett smycke i besökarens enhet (localStorage). Första gången
 * frågar en dialog efter e-post: med den bevakar plattformen smycket och mejlar
 * om någon annan lägger det i varukorgen, om priset sänks eller om det säljs.
 * Utan e-post sparas det bara lokalt.
 *
 * Skickar också en anonym varukorgssignal (temats "variant:add") — det är den
 * som driver "någon annan har ditt sparade smycke i varukorgen".
 *
 * All kommunikation går till /apps/pf/watch (App Proxy → PF OS).
 */
(function () {
  "use strict";
  var KEY = "pf-watch-v1";
  var CID = "pf-cid";
  var dialog = document.querySelector("[data-pf-watch-dialog]");
  if (!dialog) return;
  var endpoint = dialog.getAttribute("data-endpoint");
  var ctx = {
    locale: dialog.getAttribute("data-locale") === "sv" ? "sv" : "en",
    market: dialog.getAttribute("data-market") || undefined,
    country: dialog.getAttribute("data-country") || undefined,
    currency: dialog.getAttribute("data-currency") || undefined,
  };

  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || "null");
      return s && Array.isArray(s.items) ? s : { items: [] };
    } catch (e) {
      return { items: [] };
    }
  }
  function save(s) {
    try {
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) {}
    paint();
    if (typeof renderSaved === "function") renderSaved();
  }
  function clientId() {
    try {
      var c = localStorage.getItem(CID);
      if (!c) {
        c = window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2) + Date.now();
        localStorage.setItem(CID, c);
      }
      return c;
    } catch (e) {
      return undefined;
    }
  }
  function post(body) {
    var payload = Object.assign({ client_id: clientId() }, ctx, body);
    return fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (d) { return !!(r.ok && d && d.ok); });
      })
      .catch(function () { return false; });
  }

  function paint() {
    var s = load();
    var ids = {};
    s.items.forEach(function (i) { ids[String(i.id)] = true; });
    document.querySelectorAll("[data-pf-heart]").forEach(function (b) {
      b.setAttribute("aria-pressed", ids[b.getAttribute("data-product-id")] ? "true" : "false");
    });
    document.querySelectorAll("[data-pf-saved-dot]").forEach(function (d) { d.hidden = s.items.length === 0; });
    document.querySelectorAll("[data-pf-saved-count]").forEach(function (d) { d.textContent = s.items.length ? "(" + s.items.length + ")" : ""; });
  }

  function itemFrom(b) {
    return {
      id: b.getAttribute("data-product-id"),
      h: b.getAttribute("data-handle"),
      t: b.getAttribute("data-title"),
      i: b.getAttribute("data-image"),
      p: b.getAttribute("data-price"),
      at: Date.now(),
    };
  }

  /* Koppla e-post till ALLT som sparats på enheten (senaste först, max 20) —
     används av dialogen och av notisen i panelen. */
  function subscribeAll(email, extraId) {
    var s = load();
    var ids = s.items.slice(0, 20).map(function (i) { return String(i.id); });
    if (extraId && ids.indexOf(String(extraId)) < 0) ids.unshift(String(extraId));
    if (!ids.length) return Promise.resolve(false);
    return Promise.all(ids.map(function (id) { return post({ action: "save", product_id: id, email: email }); }))
      .then(function (results) {
        if (!results.some(Boolean)) return false;
        var s2 = load();
        s2.email = email;
        s2.asked = true;
        save(s2);
        return true;
      });
  }

  var pending = null;
  function openDialog(item) {
    pending = item;
    var form = dialog.querySelector("[data-pf-watch-form]");
    var success = dialog.querySelector("[data-pf-success]");
    var intro = dialog.querySelector("[data-pf-intro]");
    if (form) { form.hidden = false; form.style.display = ""; }
    if (intro) intro.style.display = "";
    if (success) success.hidden = true;
    if (typeof dialog.showModal === "function") dialog.showModal();
  }

  function toggle(b) {
    var s = load();
    var id = b.getAttribute("data-product-id");
    var idx = s.items.findIndex(function (i) { return String(i.id) === id; });
    if (idx >= 0) {
      s.items.splice(idx, 1);
      save(s);
      if (s.email) post({ action: "unsave", product_id: id, email: s.email });
      return;
    }
    var item = itemFrom(b);
    s.items.unshift(item);
    s.items = s.items.slice(0, 100);
    save(s);
    if (s.email) {
      post({ action: "save", product_id: id, email: s.email });
    } else {
      post({ action: "save", product_id: id });
      if (!s.asked) openDialog(item);
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var b = e.target.closest && e.target.closest("[data-pf-heart]");
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      toggle(b);
    },
    true,
  );

  // ── Dialogen ──────────────────────────────────────────────────────────
  (function () {
    var form = dialog.querySelector("[data-pf-watch-form]");
    var errorEl = dialog.querySelector("[data-pf-error]");
    var success = dialog.querySelector("[data-pf-success]");
    var intro = dialog.querySelector("[data-pf-intro]");
    dialog.querySelectorAll("[data-pf-close]").forEach(function (x) { x.addEventListener("click", function () { dialog.close(); }); });
    dialog.addEventListener("click", function (e) { if (e.target === dialog) dialog.close(); });
    var skip = dialog.querySelector("[data-pf-skip]");
    if (skip) skip.addEventListener("click", function () {
      var s = load();
      s.asked = true;
      save(s);
      dialog.close();
    });
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      if (errorEl) errorEl.hidden = true;
      var fd = new FormData(form);
      if (String(fd.get("website") || "").trim()) return;
      var email = String(fd.get("email") || "").trim().toLowerCase();
      var btn = form.querySelector('button[type="submit"]');
      if (btn) btn.disabled = true;
      subscribeAll(email, pending && pending.id)
        .then(function (ok) {
          if (ok) {
            form.hidden = true;
            form.style.display = "none";
            if (intro) intro.style.display = "none";
            if (success) success.hidden = false;
            setTimeout(function () { dialog.close(); }, 1800);
          } else if (errorEl) {
            errorEl.hidden = false;
          }
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  })();

  // ── Varukorgssignalen ─────────────────────────────────────────────────
  document.addEventListener("variant:add", function (e) {
    var items = (e.detail && e.detail.items) || [];
    items.forEach(function (it) {
      if (it && it.product_id) post({ action: "event", kind: "add_to_cart", product_id: String(it.product_id) });
    });
  });

  // ── "Meddela mig när liknande" (slutsålda produktsidor) ───────────────
  document.querySelectorAll("[data-pf-notify-form]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var fd = new FormData(form);
      if (String(fd.get("website") || "").trim()) return;
      var email = String(fd.get("email") || "").trim().toLowerCase();
      var btn = form.querySelector('button[type="submit"]');
      var err = form.querySelector("[data-pf-error]");
      if (btn) btn.disabled = true;
      if (err) err.hidden = true;
      post({ action: "notify_similar", product_id: form.getAttribute("data-product-id"), email: email })
        .then(function (ok) {
          if (ok) {
            var root = form.closest("[data-pf-notify]") || form;
            var done = root.querySelector("[data-pf-success]");
            form.hidden = true;
            form.style.display = "none";
            if (done) done.hidden = false;
            var s = load();
            if (!s.email) { s.email = email; save(s); }
          } else if (err) {
            err.hidden = false;
          }
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  // ── Sparade smycken: panelen (glider upp) och sidan /apps/pf/sparade ──
  // Korten är temats EGNA produktkort, renderade av Shopify via den
  // alternativa mallen product.pf-card (/products/<handle>?view=pf-card).
  // Då blir padding, typografi, färgschema och pris i besökarens marknad
  // exakt som i kollektionerna — inga egna värden här. Cachas under besöket.
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var sv = ctx.locale === "sv";
  var cards = {};
  function fetchCard(h) {
    if (!cards[h]) {
      cards[h] = fetch(root + "products/" + encodeURIComponent(h) + "?view=pf-card")
        .then(function (r) { return r.ok ? r.text() : null; })
        .catch(function () { return null; });
    }
    return cards[h];
  }
  function renderSaved() {
    var lists = document.querySelectorAll("[data-pf-saved-list]");
    if (!lists.length) return;
    var s = load();
    document.querySelectorAll("[data-pf-saved-empty]").forEach(function (e) { e.hidden = s.items.length > 0; });
    document.querySelectorAll("[data-pf-saved-notice]").forEach(function (n) {
      // Behåll tack-texten synlig direkt efter att e-posten angetts.
      if (n.getAttribute("data-done") === "1") return;
      n.hidden = !(s.items.length > 0 && !s.email);
    });
    var closeTpl = document.getElementById("pf-close-icon");
    lists.forEach(function (list) {
      list.innerHTML = "";
      // Korten läggs DIREKT i temats product-list (subgrid ger dem samma form
      // som i kollektionerna); en platshållare per smycke håller ordningen.
      s.items.forEach(function (it) {
        var slot = document.createElement("div");
        list.appendChild(slot);
        fetchCard(it.h).then(function (html) {
          if (!html || !slot.parentNode) return;
          var holder = document.createElement("div");
          holder.innerHTML = html;
          var card = holder.querySelector("product-card, .product-card");
          if (!card) return slot.remove();
          var rm = document.createElement("button");
          rm.type = "button";
          rm.className = "pf-saved__remove";
          rm.setAttribute("aria-label", (sv ? "Ta bort " : "Remove ") + (it.t || ""));
          if (closeTpl) rm.appendChild(closeTpl.content.cloneNode(true));
          rm.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            var s2 = load();
            s2.items = s2.items.filter(function (x) { return String(x.id) !== String(it.id); });
            save(s2);
            if (s2.email) post({ action: "unsave", product_id: String(it.id), email: s2.email });
          });
          card.appendChild(rm);
          slot.replaceWith(card);
        });
      });
    });
  }

  document.querySelectorAll("[data-pf-notice-form]").forEach(function (form) {
    var box = form.closest("[data-pf-saved-notice]");
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!form.reportValidity()) return;
      var fd = new FormData(form);
      if (String(fd.get("website") || "").trim()) return;
      var err = box.querySelector("[data-pf-error]");
      var done = box.querySelector("[data-pf-success]");
      var btn = form.querySelector('button[type="submit"]');
      if (err) err.hidden = true;
      if (btn) btn.disabled = true;
      subscribeAll(String(fd.get("email") || "").trim().toLowerCase())
        .then(function (ok) {
          if (ok) {
            box.setAttribute("data-done", "1");
            form.hidden = true;
            form.style.display = "none";
            if (done) done.hidden = false;
          } else if (err) {
            err.hidden = false;
          }
        })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  });

  paint();
  renderSaved();
  document.addEventListener("shopify:section:load", paint);
  // Kollektionssidor laddar kort dynamiskt (filter, sidbyte) — måla om.
  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () { scheduled = false; paint(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
